"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prefix = exports.InputWrapper = exports.PhoneInput = exports.AadhaarInput = exports.SVGWrapper = exports.FormLabel = exports.Title = exports.Button = exports.ImageWrapper = exports.Error = exports.HeaderWrapper = exports.Container = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
exports.Container = building_blocks_ui_common_1.styled.div `
  width: 100%;
  overflow: hidden;
  padding: 15px 15px;
  border-radius: 9px;
  background: linear-gradient(180deg, #fff 0%, #f5fbff 100%);
  box-shadow: 0px 9px 19px 0px rgba(0, 0, 0, 0.1),
    0px 35px 35px 0px rgba(0, 0, 0, 0.09), 0px 79px 48px 0px rgba(0, 0, 0, 0.05),
    0px 141px 56px 0px rgba(0, 0, 0, 0.01), 0px 220px 62px 0px rgba(0, 0, 0, 0);
`;
exports.HeaderWrapper = building_blocks_ui_common_1.styled.div `
  display: flex;
  position: relative;
  border-radius: 9px;
  > * {
    width: 50%;
  }
`;
exports.Error = building_blocks_ui_common_1.styled.p `
  color: red;
  font-size: 12px;
  margin: 4px 0;
`;
exports.ImageWrapper = building_blocks_ui_common_1.styled.div `
  display: flex;
  align-item: center;
  justify-content: center;
`;
exports.Button = building_blocks_ui_common_1.styled.button `
  border-radius: 8px;
  background: #0fa457;
  border: 0;
  color: #fff;
  padding: 15px 15px;
  width: 100%;
  margin-top: 12px;
`;
exports.Title = building_blocks_ui_common_1.styled.h2 ``;
exports.FormLabel = building_blocks_ui_common_1.styled.label `
  color: var(--text-secondary-n-400, #5b5675);
  font-feature-settings: 'dlig' on;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  margin-top: 12px;
  display: inline-block;
  & + form {
    margin-top: 4px;
    > p {
      display: none;
    }
  }
`;
exports.SVGWrapper = building_blocks_ui_common_1.styled.div `
  position: absolute;
  top: -15px;
  left: -15px;
  width: 288px;
  height: 225px;
`;
exports.AadhaarInput = building_blocks_ui_common_1.styled.input `
  width: 100%;
  border: none;
  border: 1px solid #e7e7f0;
  border-radius: 8px;
  padding: 16px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  width: 100%;
  outline: none;
  text-transform: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  caret-color: #5b5675;
  color: #040222;
  -webkit-appearance: none;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
`;
exports.PhoneInput = (0, building_blocks_ui_common_1.styled)(exports.AadhaarInput) `
  padding-left: 50px;
`;
exports.InputWrapper = building_blocks_ui_common_1.styled.div `
  position: relative;
`;
exports.Prefix = building_blocks_ui_common_1.styled.span `
  position: absolute;
  top: 18px;
  left: 18px;
  z-index: 1;
`;
//# sourceMappingURL=styles.js.map